
import {css} from 'glamor';

export const heading1 = css({
  fontWeight: 300,
  fontSize: '32px',
  letterSpacing: 0.25,
});

export const heading2 = css({
  fontWeight: 300,
  fontSize: '28px',
  letterSpacing: 0.15,
});

export const subtitle1 = css({
  fontWeight: 400,
  fontSize: '24px',
  letterSpacing: 0,
});

export const subtitle2 = css({
  fontWeight: 400,
  fontSize: '20px',
  letterSpacing: 0.15,
});

export const bodyText1 = css({
  fontWeight: 400,
  fontSize: '16px',
  letterSpacing: 0.5,
});

export const bodyText2 = css({
  fontWeight: 400,
  fontSize: '14px',
  letterSpacing: 0.25,
});

export const bodyText3 = css({
  fontWeight: 400,
  fontSize: '12px',
  letterSpacing: 0.4,
});

export const caption = css({
  fontWeight: 700,
  fontSize: '10px',
  letterSpacing: 0.8,
  textTransform: 'uppercase',
});
